TrelloModel = require 'models/internal/trello-model'

module.exports = class PendingOrganization extends TrelloModel
  typeName: 'PendingOrganization'



// WEBPACK FOOTER //
// ./app/scripts/models/pending-organization.coffee